import React from "react";
import { useNavigate } from "react-router-dom";

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white p-6 relative">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
          Refund Policy
        </h1>
        {/* <p className="mt-2 text-sm sm:text-base opacity-80">
          Last updated: August 2025
        </p> */}
      </header>

      {/* Content Section */}
      <main className="flex-grow max-w-4xl mx-auto bg-white bg-opacity-10 rounded-2xl shadow-lg p-6 sm:p-10 overflow-y-auto">
        <section className="mb-6">
          <p className="text-sm sm:text-base opacity-90 leading-relaxed">
            Our focus is complete customer satisfaction. Subscription Plans are
            refundable upon cancellation, up to 15 working days post purchase.
            Purchases can be via{" "}
            <span className="font-semibold">aicahealth.com</span> and{" "}
            <span className="font-semibold">Aica Health mobile application(s)</span>.
          </p>
          <p className="text-sm sm:text-base opacity-90 leading-relaxed mt-4">
            The refund processing time is 15 working days. Refunds will be credited
            within 10 working days post deduction of banking and payment gateway
            charges, after processing.
          </p>
        </section>
      </main>

      {/* Footer Section */}
      <footer className="py-4 bg-black bg-opacity-20 text-center mt-6">
        <p className="text-sm">
          Powered by <span className="font-semibold">AICA</span> | Your Smart Health Assistant
        </p>
        <button
          onClick={() => navigate(-1)}
          className="mt-2 px-4 py-2 bg-white text-teal-600 rounded-lg shadow hover:bg-gray-200 transition"
        >
          Go Back
        </button>
      </footer>
    </div>
  );
};

export default RefundPolicy;
